import PropTypes from 'prop-types';
import React from 'react';
import { Page } from '../..';
import logo from '../../../logo.png';
import Box from '../Box';
import './styles.scss';

export const AuthPage = ({ children, heading, isHost }) => {
  return (
    <Page className="auth-page card depth-3">
      <Box justifyContent="space-between" alignItems="center"
        className="header theme-background"
        direction="row">
        <h1>{heading}</h1>
        {isHost == false ? <img className="logo" src="" alt="" /> : <img className="logo" src={logo} alt="" />}
      </Box>
      {children}
    </Page>
  );
};

AuthPage.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  heading: PropTypes.string,
};

export default AuthPage;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/layout/AuthPage/index.js